import '../css/App.css';
import { useDocumentTitle } from '../ts/useDocumentTitle';

function GamePage() {
  useDocumentTitle('Game Page');
  return (
    <div className="Game">
      <header className="Game-header">

      </header>
      
    </div>

  );
}

export default GamePage;